document.addEventListener("DOMContentLoaded", function () {
  // Check if #collection-slider exists before initializing Splide
  const collectionSlider = document.querySelector("#collection-slider");
  if (collectionSlider) {
    new Splide(collectionSlider, {
      type: "loop",
      perPage: 2,
      perMove: 1,
      gap: "30px",
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    }).mount();
  }

  class MarqueWebComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeSplide();
    }

    initializeSplide() {
      const marqueElement = this.querySelector(".marque");
      if (!marqueElement) return; // Ensure element exists

      const marque = new Splide(marqueElement, {
        type: "loop",
        drag: "free",
        focus: "center",
        arrows: false,
        pagination: false,
        perPage: 4,
        autoWidth: true,
        autoScroll: {
          speed: 1,
        },
        breakpoints: {
          767: {
            perPage: 3,
          },
          576: {
            perPage: 2,
          },
        },
      });

      marque.mount(window.splide?.Extensions || {});
    }
  }

  customElements.define("marque-component", MarqueWebComponent);
});

// PRODUCT PAGE TAB
function openTab(event, tabId) {
  var tabs = document.querySelectorAll(".tab");
  var contents = document.querySelectorAll(".tab-content");
  var targetContent = document.getElementById(tabId);

  if (!targetContent) return;

  tabs.forEach((tab) => tab.classList.remove("active"));
  contents.forEach((content) => content.classList.remove("active"));

  event.currentTarget.classList.add("active");
  targetContent.classList.add("active");
}
